import PropTypes from "prop-types";
// form
import { useForm } from "react-hook-form";
// @mui
import { LoadingButton } from "@mui/lab";
import { Card, InputAdornment, Stack } from "@mui/material";
// components
import FormProvider, { RHFTextField } from "@/core/components/hook-form";
import Iconify from "@/core/components/iconify";
import { useSnackbar } from "@/core/components/snackbar";

// ----------------------------------------------------------------------

const SOCIAL_LINKS = [
  {
    value: "facebookLink",
    icon: (
      <Iconify
        icon="eva:facebook-fill"
        width={24}
      />
    ),
  },
  {
    value: "instagramLink",
    icon: (
      <Iconify
        icon="ant-design:instagram-filled"
        width={24}
      />
    ),
  },
  {
    value: "linkedinLink",
    icon: (
      <Iconify
        icon="eva:linkedin-fill"
        width={24}
      />
    ),
  },
  {
    value: "twitterLink",
    icon: (
      <Iconify
        icon="eva:twitter-fill"
        width={24}
      />
    ),
  },
];

// ----------------------------------------------------------------------

AccountSocialLinks.propTypes = {
  socialLinks: PropTypes.shape({
    facebookLink: PropTypes.string,
    instagramLink: PropTypes.string,
    linkedinLink: PropTypes.string,
    twitterLink: PropTypes.string,
  }),
};

export default function AccountSocialLinks({ socialLinks }) {
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    facebookLink: socialLinks.facebookLink,
    instagramLink: socialLinks.instagramLink,
    linkedinLink: socialLinks.linkedinLink,
    twitterLink: socialLinks.twitterLink,
  };

  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      enqueueSnackbar("Update success!");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider
      methods={methods}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Card sx={{ p: 3 }}>
        <Stack
          spacing={3}
          alignItems="flex-end"
        >
          {SOCIAL_LINKS.map((link) => (
            <RHFTextField
              key={link.value}
              name={link.value}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">{link.icon}</InputAdornment>
                ),
              }}
            />
          ))}

          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Save Changes
          </LoadingButton>
        </Stack>
      </Card>
    </FormProvider>
  );
}
